import React from 'react'
import 'animate.css'
import './AboutData.css'

function AboutData() {
    return (
        <div className="aboutdata">
           <h1 className="animate__animated animate__fadeInUp animate__delay-1s">HELLO WE'RE STUDENTS OF GCE</h1>
           <h4 className="animate__animated animate__fadeInUp animate__delay-2s">TRAVELLING OUR UNIQUE JOURNEY TO SUCCESS</h4>
           <button className="animate__animated animate__fadeInUp animate__delay-3s"><span>SEE OUR PROJECTS</span></button>
        </div>
    )
}

export default AboutData
